import { useQuery, useMutation } from "react-query";
import {
	getAllTransactionsDetails_api,
	get_all_transactions_history_api,
	get_all_transactions_orders_api,
	getAllPaymentHistoryDetails_api,
	downloadTransactionOrders_api,
	downloadTransactionsHistory_api,
	getAllDashboardDetails_api,
	get_restaurant_payouts_balance_api,
	add_restaurant_payouts_stripe_api,
	getUnclaimedPayouts,
	initiateUnclaimedTransfer,
} from "../services/payouts";

export const usegetAllTransactionsHistory = (payload) =>
	useQuery(["getAllTransactionsHistory", payload], () =>
		get_all_transactions_history_api(payload)
	);

export const usegetAllTransactionsOrders = (payload) =>
	useQuery(["getAllTransactionsOrders", payload], () =>
		get_all_transactions_orders_api(payload)
	);

export const useGetTransactionsDetails = (params) =>
	useQuery(["getTransactionsDetails", params], () =>
		getAllTransactionsDetails_api(params)
	);

export const useGetPaymentHistoryDetails = (params) =>
	useQuery(["getPaymentHistoryDetails", params], () =>
		getAllPaymentHistoryDetails_api(params)
	);

export const useDownloadTransactionOrders = () =>
	useMutation("downloadTransactionsOrders", (payload) =>
		downloadTransactionOrders_api(payload)
	);

export const useDownloadTransactionsHistory = () =>
	useMutation("downloadTransactionsHistory", (payload) =>
		downloadTransactionsHistory_api(payload)
	);

export const useGetAllDashboard = (payload) =>
	useQuery(["getAllDashboard", payload], () =>
		getAllDashboardDetails_api(payload)
	);

export const useGetRevenueDashboard = (payload) =>
	useQuery(["getRevenueDashboard", payload], () =>
		getAllDashboardDetails_api(payload)
	);

export const useGetOrdersDashboard = (payload) =>
	useQuery(["getOrdersDashboard", payload], () =>
		getAllDashboardDetails_api(payload)
	);

export const usegetRestaurantPayoutsBalance = (params) =>
	useQuery(
		["getRestaurantPayoutsBalance", params],
		() => get_restaurant_payouts_balance_api(params),
		{
			enabled: !!params,
		}
	);

export const useCreateRestaurantPayouts = () =>
	useMutation("createRestaurantPayouts", (payload) =>
		add_restaurant_payouts_stripe_api(payload)
	);

export const useGetUnclaimedPayout = (payload) =>
	useQuery(
		["getUnclaimedPayout", payload],
		() => getUnclaimedPayouts(payload)
		// { enabled: false }
	);

export const useInitiateUnclaimedTransfer = () =>
	useMutation("InitiateTransaction", (payload) =>
		initiateUnclaimedTransfer(payload)
	);
